<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="campaigncharts" *ngIf="filterApplied">
        <div class="ui-g">
            <div class="ui-g-12 ui-md-8 ui-sm-12">
                <h2>{{ translations.promoUsersPerSegment }}</h2>
                <div class="chart-container">
                    <chart [options]="averageDiscountPerSegmentChart.options"
                           (load)="setChartInstance(averageDiscountPerSegmentChart, $event.context)"></chart>
                </div>
            </div>

            <div class="ui-g-12 ui-md-4 ui-sm-12">
                <h2>{{ translations.averageDiscountPerSegment }}</h2>
                <div class="chart-container">
                    <chart [options]="promoUsersPerSegmentChart.options"
                           (load)="setChartInstance(promoUsersPerSegmentChart, $event.context)"></chart>
                </div>
            </div>
        </div>

        <div class="ui-g">
            <div class="ui-g-12 ui-md-8 ui-sm-12">
                <h2>{{ translations.associatedExpenditurePerSegment }}</h2>
                <div class="chart-container">
                    <chart [options]="associatedExpenditurePerSegmentChart.options"
                           (load)="setChartInstance(associatedExpenditurePerSegmentChart, $event.context)"></chart>
                </div>
            </div>

            <div class="ui-g-12 ui-md-4 ui-sm-12">
                <h2>{{ translations.redemptionPerSegment }}</h2>
                <div class="chart-container">
                    <chart [options]="redemptionPerSegmentChart.options"
                           (load)="setChartInstance(redemptionPerSegmentChart, $event.context)"></chart>
                </div>
            </div>
        </div>
    </div>

    <p-dialog header="Error" [(visible)]="promoError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
        <p>{{ selectOneError }}</p>
        <div class="ui-dialog-footer">
            <button pButton type="button" class="slim red-button" (click)="toogleErrorPromoDialog()" label="Ok"></button>
        </div>
    </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/customer/value/promo-value.component.html